import React from 'react'
import { Grid, Paper, Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { dateFormatter } from 'utils/data-manipulation/valueFormatter'
interface MiniDispatchProps {
  customerName: string
  dispatchNumber: number
  scheduleDate: string
  count?: number
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  border: '1px solid black',
  height: '2.25in',
  padding: theme.spacing(1),
  margin: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}))

const MiniDispatchTag: React.FC<{ index: number } & MiniDispatchProps> = ({
  customerName,
  dispatchNumber,
  index,
  scheduleDate,
}) => (
  <StyledPaper elevation={0}>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Typography variant="h5" fontWeight="bold">
        {index + 1}
      </Typography>
      <Typography variant="h5" fontWeight="bold">
        {dispatchNumber}
      </Typography>
    </Box>

    <Box display="flex" flexDirection="column" justifyContent="space-between" alignItems="start">
      <Typography variant="h5" fontWeight="bold">
        {customerName}
      </Typography>
      <Typography variant="body1">{scheduleDate}</Typography>
    </Box>

    <Box mt={1}>
      <Typography variant="body2">DRUMS: ______________________</Typography>
      <Typography variant="body2">TOTES: ______________________</Typography>
      <Typography variant="body2">OTHER: ______________________</Typography>
      <Typography variant="body2">NOTES: _____________________________________</Typography>
    </Box>
  </StyledPaper>
)

const PrintableMiniDispatch: React.FC<MiniDispatchProps> = ({
  customerName,
  dispatchNumber,
  scheduleDate,
  count = 8,
}) => {
  return (
    <Box>
      <Grid container>
        {Array.from({ length: count }).map((_, index) => (
          <Grid item xs={6} key={index}>
            <MiniDispatchTag
              index={index}
              customerName={customerName}
              dispatchNumber={dispatchNumber}
              scheduleDate={dateFormatter(scheduleDate, null, {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
              })}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default PrintableMiniDispatch
